import React from 'react'

const FireCal = () => {
  return (
    <div>FireCal</div>
  )
}

export default FireCal